export default {
  set(key, payload) {
    localStorage.setItem(key, JSON.stringify(payload));
  },
  get(key) {
    return JSON.parse(localStorage.getItem(key));
  },
  removeStorageFrom(key) {
    localStorage.removeItem(key);
  },
};
